var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConUpworkIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "con_upwork_icn",
    transform: "translate(0 -0.001)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21987",
    "data-name": "Path 21987",
    d: "M10.741,18,12.5,9.757a15.8,15.8,0,0,1-.979-1.44,5.8,5.8,0,0,1-5.742,5.09A5.791,5.791,0,0,1,0,7.606V0H3.735V7.607a2.046,2.046,0,0,0,4.091,0V0h3.607l.106.359A22.5,22.5,0,0,0,13.63,5.251a5.8,5.8,0,0,1,5.428-3.726,5.939,5.939,0,1,1,0,11.877,7.148,7.148,0,0,1-3.344-.829L14.563,18Zm5.794-9.27a4.26,4.26,0,0,0,2.523.93,2.2,2.2,0,1,0,0-4.4c-1.548,0-2.13,1.44-2.346,2.647Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConUpworkIcn);
export default __webpack_public_path__ + "static/media/con_upwork_icn.0be7d05e5d5ffbebd1f3eccb36cfefbd.svg";
export { ForwardRef as ReactComponent };